module.exports = __webpack_public_path__ + "img/Application_3.1db59bb2.png";